import {zonedTimeToUtc} from "date-fns-tz";

const LOCALE = 'en-US';
const TZ_ORIGIN = 'America/New_York'; // RIMS dates + times are stored - and returned to UI - as EST/EDT
const TZ_GMT = 'UTC';

export function formatDateOfBirth(dt) {
 // we don't really want to 'format' birthday with timezone...
  if (dt) {
    return `${dt.substr(5, 2)}/${dt.substr(8, 2)}/${dt.substr(0, 4)}`;
  }
  return '';
}

export function formatWeekday(dt) {
 // we don't really want to 'format' birthday with timezone...
  if (dt) {
    const wd = getParsableDatetime(dt);
    return wd.toLocaleDateString(LOCALE, { timeZone: TZ_GMT, weekday: 'long' })
  }
  return '';
}

export function formatMonthDay(dt) {
  if (dt) {
    const wd = getParsableDatetime(dt);
    return wd.toLocaleDateString(LOCALE, { timeZone: TZ_GMT, month: 'short', day: 'numeric' });
  }
  return '';
}

export function formatMonthDayYear(dt) {
  if (dt) {
    const wd = getParsableDatetime(dt);
    return wd.toLocaleDateString(LOCALE, { timeZone: TZ_GMT, year: 'numeric', month: 'long', day: 'numeric' });
  }
  return '';
}

export function formatTime(dt) {
  if (dt) {
    const wd = new Date(`2021-03-31T${dt}Z`);  // only time component is important
    return wd.toLocaleTimeString(LOCALE, { timeZone: TZ_GMT, hour: 'numeric', minute: '2-digit', hour12: true });
  }
  return dt;
}

export function formatTimeOfDay(str) {
if (str === 'AM') {
    return 'Morning';
  } else if (str === 'PM') {
    return 'Afternoon';
  } else {
    return str;
  }
}
/**
 * Formats currency in USD only.
*/
export const toCurrency = val => {
  if (typeof val !== 'number') {
    return val;
  }

  const formatter = new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: 'USD'
  });

  return formatter.format(val);
}

/**
 * Once upon a time, Google Translate in non-English languages messed up datetime parsing so
 * additional cleansing was required. RI DMV no longer uses Google Translate but the timezone
 * ambiguity (from RIMS) persists since RIMS never specifies timezone in their datetime objects.
 * Note: RIMS always returns datetime ISO string in ET timezone.
 * @param dt
 * @returns {Date}
 */
function getParsableDatetime(dt) {
  // datetime changed by Google Translate can mess up parsing so replace time component
  const cleaned = dt.substr(0, 10);

  // convert ET to UTC for formatting later
  const utcDate = zonedTimeToUtc(`${cleaned}T00:00:00`, TZ_ORIGIN);
  return new Date(utcDate.toISOString());
}
